<div class="console_modal device_model_dialog">
    <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2">
            <span class="badge bg-primary-subtle text-primary p-2">
                <span class="material-symbols-outlined">mobile</span>
            </span>
            <span>Modello</span>
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
    </div>

    <div class="modal-body" [spinnerLoader]="saveModelSubscription && !saveModelSubscription.closed">
        <div class="container-fluid">
            <form class="row row-gap-2" novalidate>
                <div class="col-6 position-relative">
                    <fs-vendor-select [formField]="deviceModel.assetVendorId" />
                </div>
                <div class="col-6">
                    <label for="modelName" class="form-label">Modello</label>
                    <input type="text" id="modelName" class="form-control" [formField]="deviceModel.name" [class.is-invalid]="deviceModel.name().invalid() && deviceModel.name().touched()">
                    @for (error of deviceModel.name().errors(); track $index) {
                        <div class="invalid-feedback">{{ error.message }}</div>
                    }
                </div>
                <div class="col-6">
                    <fs-asset-type-select [formField]="deviceModel.assetTypeId" />
                </div>
                <div class="col-6">
                    <label class="form-label" for="modelEnabled">Attivo</label>
                    <div class="form-check form-switch">
                        <input type="checkbox" class="form-check-input" id="modelEnabled" [formField]="deviceModel.enabled">
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Chiudi</button>
        <button type="button" class="btn btn-primary" (click)="saveModel()">Salva</button>
    </div>
</div>